import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import DashboardPage from './pages/dashboard/DashboardPage';
import { OktaSecurity } from './components/general/OktaSecurity.tsx';
import SignInPage from './pages/sign-in/SignInPage';
import { OktaCallbackPage } from './pages/okta-callback/OktaCallbackPage';
import { InitialRouteHandler } from './components/general/InitialRouteHandler';
import { DialogQueueRenderer } from './components/general/DialogQueueRenderer';

function AppRoutes() {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <>
      <OktaSecurity restoreOriginalUri={restoreOriginalUri}>
        <InitialRouteHandler>
          <Routes>
            <Route path='/sign-in' element={<SignInPage />} />
            <Route path='/okta-callback' element={<OktaCallbackPage />} />
            <Route path='/' element={<DashboardPage />} />
          </Routes>
        </InitialRouteHandler>
        <DialogQueueRenderer />
      </OktaSecurity>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
